/* src/app/core/layout/sidebar/sidebar.component.scss */
.sidebarContainer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 4.5rem;
  display: flex;
  flex-direction: column;
  background:
    linear-gradient(
      180deg,
      #2c3e50 0%,
      #1b2733 100%);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.25);
  z-index: 1040;
  overflow: hidden;
  transition: width 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebarContainer .sidebarBrand {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  height: 3.5rem;
  background: rgba(0, 0, 0, 0.15);
}
.sidebarContainer .sidebarBrand .logo {
  height: 1.9rem;
  max-width: 78%;
  object-fit: contain;
}
.sidebarContainer .collapseToggle {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.7rem 0;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.sidebarContainer .collapseToggle span {
  font-size: 0.7rem;
  letter-spacing: 0.03em;
}
.sidebarContainer .collapseToggle:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}
.sidebarContainer .menuItems {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  list-style: none;
  margin: 0;
  padding: 0.6rem 0;
  color: white;
}
.sidebarContainer .menuItems::-webkit-scrollbar {
  width: 6px;
}
.sidebarContainer .menuItems::-webkit-scrollbar-track {
  background: transparent;
}
.sidebarContainer .menuItems::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}
.sidebarContainer .menuItems::-webkit-scrollbar-thumb:hover {
  background: #f99420;
}
.sidebarContainer .menuItems li {
  display: block;
  margin: 0;
  padding: 0;
}
.sidebarContainer .menuItems a {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0.15rem 0.6rem;
  padding: 0.65rem 0.8rem;
  border-radius: 0.6rem;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.72rem;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.sidebarContainer .menuItems a .fa-fw {
  flex: 0 0 auto;
  font-size: 1rem;
  text-align: center;
}
.sidebarContainer .menuItems a:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: #fff;
}
.sidebarContainer .menuItems a.active {
  background:
    linear-gradient(
      135deg,
      #f99420,
      #e07f0e);
  color: #fff;
  box-shadow: 0 2px 10px rgba(249, 148, 32, 0.4);
}
.sidebarContainer .menuItems .subMenu {
  padding: 0.2rem 0;
  margin: 0 0.6rem 0.3rem;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 0.6rem;
}
.sidebarContainer .menuItems .subItemLink {
  margin: 0.15rem 0.4rem;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.68rem;
  font-weight: 400;
}
.sidebarContainer .menuItems .subItemLink:hover {
  color: #fff;
}
.sidebarContainer .menuItems .subItemLink.active {
  background: rgba(249, 148, 32, 0.22);
  color: #f99420 !important;
  box-shadow: none;
}
.sidebarContainerFull {
  width: 16rem;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.35);
}
.sidebarContainerFull .collapseToggle {
  justify-content: flex-start;
  padding-left: 1.25rem;
}
.sidebarContainerFull .menuItems {
  text-align: left;
}
.sidebarContainerFull .menuItems a {
  width: auto;
}
.itemLabel {
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=sidebar.component.css.map */
